//messages.js
export default {
    template_id: "Template #",
    template_name: "Template Name",
    slug: "Slug",
    image: "Image",
    log_version: "Version",
    active: "Active",
    edit_log_template: "Edit Log Template",
    add_log_template: "Add Log Template",
    delete_log_template: "Delete Log Template",
    log_templates: "Log Templates",
    delete_log_template_confirm: "This action is not reversible!",
    log_templates: "Log Templates",
    log_template: "Log Template",
    modify_log_template: "Modify Log Template",
    capture: "Capture",
    edit_question: "Edit Question",
    add_question: "Add Question",
    frequency_interval: "Frequency Interval",
    frequency: "Frequency",
    parameter: "Parameter",
};
